import styled from 'styled-components';

export const Container = styled.button`
  max-width: 50px;
  max-height: 50px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.metrics.padding};
  border-radius: 50px;
  transition: all 0.1s;
  box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }
`;
